/* =========================================================
   DOPAMEAN — PDP subtitle reformatter
   Auto-detects elements whose entire text content is a string
   of bracket-formatted measurement chunks like:
       [CHEST-42"] [LENGTH-26"]
   and reformats them into clean stacked rows:
       Chest - 42"
       Length - 26"
   Works without needing a CSS class — Shopify's richtext setting
   doesn't allow class attributes, so we discover targets by their
   text shape. Supports any label key (Chest, Length, Waist, Sleeve…).
   ========================================================= */
(function () {
  /* Matches text that is ONLY bracket-wrapped key-value pairs (each
     bracket must contain a hyphen). Whitespace between brackets is
     allowed. Prevents accidental matches on regular paragraph text. */
  var WHOLE_BRACKETS = /^\s*(\[[^\]]+-[^\]]+\]\s*)+$/;
  var EACH_BRACKET   = /\[(.*?)\]/g;

  function format(el) {
    if (!el || el.dataset.dpmSubtitleDone === '1') return;
    var text = (el.textContent || '').trim();
    if (!text) return;
    if (!WHOLE_BRACKETS.test(text)) return;

    var matches = text.match(EACH_BRACKET);
    if (!matches) return;

    var formatted = matches.map(function (item) {
      item = item.replace(/[\[\]]/g, '');
      var parts = item.split('-');
      if (parts.length < 2) return item;
      var label = parts[0]
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      var value = parts.slice(1).join('-').trim();
      return label + ' - ' + value;
    }).join('<br>');

    /* Replace inner content but preserve any wrapping tags (e.g.
       <strong>...</strong> stays as <strong>Chest - 42"<br>...). */
    el.innerHTML = formatted;
    el.classList.add('pdp-sub-title');
    el.dataset.dpmSubtitleDone = '1';
  }

  function run(root) {
    var scope = root || document;
    /* Scan candidate text holders inside the product page only. */
    var nodes = scope.querySelectorAll(
      'product-info p, product-info strong, product-info span, ' +
      '.dpm-info-panel p, .dpm-info-panel strong, .dpm-info-panel span, ' +
      '.pdp-sub-title'
    );
    nodes.forEach(format);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) run(e.target);
  });

  /* Re-run when product-info swaps variant markup (per-variant
     metafield value) so the new content gets re-formatted. */
  if (typeof MutationObserver !== 'undefined') {
    document.querySelectorAll('product-info').forEach(function (pi) {
      new MutationObserver(function () {
        pi.querySelectorAll('[data-dpm-subtitle-done]').forEach(function (el) {
          el.removeAttribute('data-dpm-subtitle-done');
        });
        run(pi);
      }).observe(pi, { childList: true, subtree: true });
    });
  }
})();
